import React, { FunctionComponent } from 'react';

import SingleYesNoStep from 'scenes/common/components/Steps/SingleYesNoStep';
import { getBusinessRegisteredForGst } from 'scenes/home/selectors';
import { HomeFullPageProps } from 'scenes/home/types';

export const STATE_KEY = 'businessRegisteredForGst';

const BusinessRegisteredForGstStep: FunctionComponent<HomeFullPageProps> = ({
  onNext,
  funnelState,
}) => {
  const question = 'Is the business registered for GST?';
  return (
    <SingleYesNoStep
      question={question}
      stateKey={STATE_KEY}
      defaultStateValue={getBusinessRegisteredForGst(funnelState)}
      onNext={onNext}
    />
  );
};

export default BusinessRegisteredForGstStep;
